/**
 * Navigate to an external URL.
 *
 * Why this helper exists:
 * - The Emergent dashboard preview wraps the site in a sandboxed iframe, where
 *   `target="_blank"` and `window.open` get swallowed and the URL resolves
 *   inside the iframe. Sites that send `X-Frame-Options: SAMEORIGIN`
 *   (e.g. api.whatsapp.com) then trigger Chrome's "ERR_BLOCKED_BY_RESPONSE".
 * - On the live, deployed site there is no parent iframe, so this just
 *   navigates the current tab (a normal redirect).
 *
 * Strategy: always navigate the TOP-level window. That breaks out of the
 * preview iframe, and on the deployed site `window.top === window.self`, so
 * it behaves identically to a plain link click.
 */
export function openExternal(url) {
    if (!url) return;
    try {
        if (window.top && window.top !== window.self) {
            window.top.location.href = url;
            return;
        }
    } catch (_) {
        // Cross-origin top frame — fall through to same-window navigation.
    }
    window.location.href = url;
}

